import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import qs from 'qs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ReactComponent as IconPdfWhite } from '../Img/icon-pdf-white.svg';
import { ReactComponent as IconScrollUp } from '../Img/scroll-up.svg';
import Page1Accueil_Operations from './Page1Accueil_Operations';
import Page2DonneesGenerales_Operations from './Page2DonneesGenerales_Operations';
import Page3Description_Operations from './Page3Description_Operations';
import Page4Echeancier_Operations from './Page4Echeancier_Operations';
import Page5MoyensMisEnOeuvre_Operations from './Page5MoyensMisEnOeuvre_Operations';
import Page6IncidencesFinancieres_Operations_Part1 from './Page6IncidencesFinancieres_Operations_part1';
import Page6IncidencesFinancieres_Operations_Part2 from './Page6IncidencesFinancieres_Operations_part2';
import Page7Evaluation_Operations from './Page7Evaluation_Operations';
import Page8Pilotage_Operations from './Page8Pilotage_Operations';

const BilanOperations = (props) =>
{
    const blue = '#069BD3';
    const green = '#59B44A';
    const purple = '#6571FE';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';

    const [aff, setAff] = useState(false);
    const [affPDF, setAffPDF] = useState(false);
    const [marge, setMarge] = useState(0);
    const pdfContentRef = useRef(null);
    const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
    const date = new Date();
    const day = date.getDate()<10?'0'+date.getDate():date.getDate();
    const month = (date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1);
    const hour = date.getHours()<10?'0'+date.getHours():date.getHours();
    const minutes = date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes();
    const dateFR = 'Le  '+day+' / '+month+' / '+date.getFullYear()+' à '+hour+':'+minutes;
    const [countPages, setCountPages] = useState(2);
    const [logo, setLogo] = useState(null);
    const [showButtonScrollUp, setShowButtonScrollUp] = useState(false);
    const width = (window.innerWidth * 0.7);
    const height = (width * (210 / 297));
    const fontsize = (height*12/890);
    const sizelogo = (width/6);

    async function mount() {
        // Récupération du logo de la commune
        const params = {
            'getOrganismes': true,
            'id': props.user.id_organisme
        }
        await axios.post('https://app-slfinance.fr/api/organismes.php', qs.stringify(params))
        .then(async (res) => {
            await setLogo(res.data[0].logo);
        })
        .catch((err) => {
            console.warn(err)
        })

        await setCountPages((props.operations.length * 8) + 1);
        await setAff(!aff);
    }

    useEffect(() => {
        if (props.user === null) {
            props.getUser();
        }
        else {
            mount();
        }
        
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setShowButtonScrollUp(true);
            } else {
                setShowButtonScrollUp(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

    }, [props.user])

    // Récupérer les années pour les incidences
    const getYears = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = 0; i < 6; i++) {
            years.push(currentYear + i);
        }
        return years;
    };

    const generateAndDownloadPDF = async () => {
        try {
            setIsGeneratingPDF(true);
            setMarge(10);
            setAff(!aff);
            
            // Créer un PDF paysage
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            // Récupérer tous les divs avec value='PDF'
            const pdfDivs = document.querySelectorAll("div[value='PDF']");
            
            if (pdfDivs.length === 0) {
                alert('Aucune page PDF trouvée');
                setIsGeneratingPDF(false);
                return;
            }

            // Convertir chaque div en image et l'ajouter au PDF
            for (let i = 0; i < pdfDivs.length; i++) {
                console.log(`Conversion de la page ${i + 1}/${pdfDivs.length}...`);
                
                // Convertir le div en canvas avec une meilleure résolution
                const canvas = await html2canvas(pdfDivs[i], {
                    scale: 2,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: '#ffffff',
                    logging: false
                });

                // Créer une image à partir du canvas
                const imgData = canvas.toDataURL('image/jpeg', 0.95);
                
                // Ajouter une nouvelle page au PDF (sauf pour la première)
                if (i > 0) {
                    pdf.addPage();
                }

                // Ajouter l'image à la page en remplissant toute la surface
                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
                
                // Calculer les proportions pour que l'image rentre parfaitement
                const imgRatio = canvas.width / canvas.height;
                const pageRatio = pageWidth / pageHeight;
                
                let finalWidth = pageWidth;
                let finalHeight = pageHeight;
                
                if (imgRatio > pageRatio) {
                    finalHeight = pageWidth / imgRatio;
                } else {
                    finalWidth = pageHeight * imgRatio;
                }
                
                const xOffset = (pageWidth - finalWidth) / 2;
                const yOffset = (pageHeight - finalHeight) / 2;
                
                pdf.addImage(imgData, 'JPEG', xOffset, yOffset, finalWidth, finalHeight);
            }

            // Télécharger le PDF
            pdf.save('Bilan_Operations.pdf');
            console.log('PDF créé avec succès');
            setMarge(0);
            setIsGeneratingPDF(false);
        } catch (error) {
            console.error('Erreur:', error);
            alert('Erreur lors de la création du PDF');
            setMarge(0);
            setIsGeneratingPDF(false);
        }
    };

    return (
        <div style={{flex: 1, position: 'relative'}}>
            
            {showButtonScrollUp && affPDF === false && (
                <button
                style={{position: 'fixed', bottom: 20, right: 20, width: (width/10), height: (height/10), border: '1px solid black', borderRadius: 5}}
                onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
                    <IconScrollUp width={(width/10)}/>
                </button>
            )}

            {affPDF === false?
            <div style={{display: 'flex'}}>

                <div style={{flex: 1}}></div>

                <div style={{flex: 1, marginTop: 20, textAlign: 'center'}}>
                    <p style={{color: purple, fontSize: 20}}>Prévisualisation du PDF</p>
                </div>

                <div style={{flex: 1}}>
                    <button
                    className='shadow-md rounded-md'
                    style={{backgroundColor: green, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5, opacity: isGeneratingPDF ? 0.6 : 1, cursor: isGeneratingPDF ? 'not-allowed' : 'pointer'}}
                    onClick={generateAndDownloadPDF}
                    disabled={isGeneratingPDF}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <IconPdfWhite width="18"/>
                            <p style={{margin: 5}}>{isGeneratingPDF ? 'Génération...' : 'Créer le PDF'}</p>
                        </div>
                    </button>
                </div>
            </div>
            :null}


            {props.user?
                affPDF === false && (
                <div style={{display: 'flex', marginTop: 0, marginBottom: 50}}>
                    <div style={{flex: 1}}></div>
                    <div ref={pdfContentRef}>
                        <div value='PDF' className='shadow-md rounded-md' style={{flex: 1, backgroundColor: 'white', width: width, height: height, marginTop: 50, padding: 0}}>
                            <Page1Accueil_Operations user={props.user} logo={logo} date={dateFR} width={width} height={height}/>
                        </div>
        
                        {props.operations.map((operation, i) =>
                        <div key={operation.id}>
                            <div value='PDF' className='shadow-md rounded-md' style={{flex: 1, backgroundColor: 'white', width: width, height: height, marginTop: 50, padding: 0}}>
                                <Page2DonneesGenerales_Operations marge={marge} operation={operation} user={props.user} logo={logo} date={dateFR} width={width} height={height} pagination={(i * 7)+1+1} countPageTotal={countPages}/>
                            </div>

                            <div value='PDF' className='shadow-md rounded-md' style={{flex: 1, backgroundColor: 'white', width: width, height: height, marginTop: 50, padding: 0}}>
                                <Page3Description_Operations marge={marge} operation={operation} user={props.user} logo={logo} date={dateFR} width={width} height={height} pagination={(i * 7)+2+1} countPageTotal={countPages}/>
                            </div>

                            <div value='PDF' className='shadow-md rounded-md' style={{flex: 1, backgroundColor: 'white', width: width, height: height, marginTop: 50, padding: 0}}>
                                <Page4Echeancier_Operations marge={marge} operation={operation} user={props.user} logo={logo} date={dateFR} width={width} height={height} pagination={(i * 7)+3+1} countPageTotal={countPages}/>
                            </div>

                            <div value='PDF' className='shadow-md rounded-md' style={{flex: 1, backgroundColor: 'white', width: width, height: height, marginTop: 50, padding: 0}}>
                                <Page5MoyensMisEnOeuvre_Operations marge={marge} operation={operation} user={props.user} logo={logo} date={dateFR} width={width} height={height} pagination={(i * 7)+4+1} countPageTotal={countPages}/>
                            </div>

                            <div value='PDF' className='shadow-md rounded-md' style={{flex: 1, backgroundColor: 'white', width: width, height: height, marginTop: 50, padding: 0}}>
                                <Page6IncidencesFinancieres_Operations_Part1 marge={marge} operation={operation} user={props.user} logo={logo} date={dateFR} width={width} height={height} pagination={(i * 8)+5+1} countPageTotal={countPages}/>
                            </div>

                            <div value='PDF' className='shadow-md rounded-md' style={{flex: 1, backgroundColor: 'white', width: width, height: height, marginTop: 50, padding: 0}}>
                                <Page6IncidencesFinancieres_Operations_Part2 marge={marge} operation={operation} user={props.user} logo={logo} date={dateFR} width={width} height={height} pagination={(i * 8)+6+1} countPageTotal={countPages}/>
                            </div>

                            <div value='PDF' className='shadow-md rounded-md' style={{flex: 1, backgroundColor: 'white', width: width, height: height, marginTop: 50, padding: 0}}>
                                <Page7Evaluation_Operations marge={marge} operation={operation} user={props.user} logo={logo} date={dateFR} width={width} height={height} pagination={(i * 8)+7+1} countPageTotal={countPages}/>
                            </div>

                            <div value='PDF' className='shadow-md rounded-md' style={{flex: 1, backgroundColor: 'white', width: width, height: height, marginTop: 50, padding: 0}}>
                                <Page8Pilotage_Operations marge={marge} operation={operation} user={props.user} logo={logo} date={dateFR} width={width} height={height} pagination={(i * 8)+8+1} countPageTotal={countPages}/>
                            </div>
                        </div>
                        )}
                    </div>
                    <div style={{flex: 1}}></div>
                </div>
                )
            :null}
        </div>
    );
}

export default BilanOperations;
